import {
  // UserSettings,
  // PatientList,
  PatientExport,
  Dashboard,
  StatisticsPID,
  StatisticsCountry,
  StatisticsGender,
  StatisticsCoverageMap
} from 'App/views/index';


import routes from 'App/autoform/routing/routes';
import * as helper from 'App/util/common/helper';
import {Full} from './containers/index';

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const toolkitRoutes = [
  {root: helper.getPath(), name: 'Home', component: Full},
  {root: helper.getPath('dashboard'), name: 'Dashboard', component: Dashboard},
  {root: helper.getPath('patient'), name: 'Patient', component: null},
  // {root: helper.getPath('patient/list'), name: 'Patient List', component: PatientList},
  {root: helper.getPath('patient/export'), name: 'Patient Export', component: PatientExport},
  // {root: helper.getPath('settings'), name: 'Settings', component: UserSettings},
  {root: helper.getPath('statistics'), name: 'Statistics', component: null},
  {root: helper.getPath('statistics/pid'), name: 'PID', component: StatisticsPID},
  {root: helper.getPath('statistics/country'), name: 'Country Distribution', component: StatisticsCountry},
  {root: helper.getPath('statistics/gender'), name: 'Gender Distribution', component: StatisticsGender},
  {root: helper.getPath('statistics/coverage'), name: 'Coverage Map', component: StatisticsCoverageMap},
  // ...routes,
];

export default toolkitRoutes;



// WEBPACK FOOTER //
// ./src/routes.js